interface Props {
  label: string;
  onRemove?: () => void;
}

export default function Chip({ label, onRemove }: Props) {
  return (
    <span className="bo-chip">
      <span>{label}</span>
      {onRemove && (
        <button type="button" onClick={onRemove} className="bo-chip__remove" aria-label="Retirer">
          ×
        </button>
      )}
    </span>
  );
}
